var app = {
	windowLoaded: function () {

	},
	windowResized: function () {
		var _main = this;
		// _main.getViewport();
	},


	events: function () {
		var _main = this;

		$('.slider-hero').slick({
			dots: false,
			fade: true,
			autoplay: true,
  			autoplaySpeed: 5000,
			pauseOnHover: false,
			pauseOnFocus: false
		});

		$('.slider-logos').slick({
			dots: false,
			fade: false,
			autoplay: true,
  			autoplaySpeed: 5000,
			pauseOnHover: false,
			pauseOnFocus: false,
			slidesToShow: 4,
  			slidesToScroll: 3,
			  responsive: [
				{
				  breakpoint: 640,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					infinite: false,
					dots: false
				  }
				},
			]
		});

		$('.hamburger').on('click', function() {
			$(this).toggleClass('active');
			$('.nav-container').toggleClass('active');
			$('header').toggleClass('has-nav');
		});

		if ($(window).width() <= 1280) {
			$('header a').on('click', function() {
				$('.hamburger').click();
			});
		}

		if ($('body').hasClass('page')) {
			// $('header ul li a').on('click', function(e) {
			// 	e.preventDefault();
			// 	var target = $(this).attr('href');
			// 	window.location.replace(base_url+target);
			// });
		} else {
			$(document).on('click', 'a[href^="#"]', function(e) {
				// target element id
				var id = $(this).attr('href');

				// target element
				var $id = $(id);
				if ($id.length === 0) {
					return;
				}

				// prevent standard hash navigation (avoid blinking in IE)
				e.preventDefault();

				// top position relative to the document
				var pos = $id.offset().top;

				// animated top scrolling
				$('body, html').animate({scrollTop: pos});
			});
		}
	},
	sections: function() {
		_main = this;

		$('section').each(function(){

			var self = $(this);

			$(this).waypoint({
				handler: function(){
					self.addClass('shown');
				},
				offset: '75%'
			});
		});

		var waypoint = new Waypoint({
			element: document.getElementById('nav-trigger'),
			handler: function(direction) {
			//   console.log('Scrolled to waypoint!')
				if (direction == 'down') {
					$('header').addClass('stick');
				} else {
					$('header').removeClass('stick');
				}
			}
		  })

	},
	init: function () {
		_main = this;
		_main.events();
		_main.sections();
		// $(window).bind('mousewheel', function() {
		// 	return false;
		// });
	},
	debug: true,

	wine_color: null,
	wine_taste: null,
	wine_type: null,

	matched_items: 0
}

$(document).ready(function () {
	app.init();
});

$(window).on('load', function () {
	app.windowLoaded();
});

$(window).resize(function () {
	app.windowResized();
});

$(document).scroll(function () {

});

// careers
$('.change-buttons li').click(function () {
	$('.change-buttons li').removeClass('active');
	$(this).addClass('active');
	var catid = $(this).data('catid');
	console.log('.box-careers[data-catid="'+catid+'"]');
	$('.box-careers').removeClass('active');
	$('.box-careers[data-catid="'+catid+'"]').addClass('active');
	$('.careers-change').removeClass('catid6').removeClass('catid7');
	$('.careers-change').addClass('catid'+catid+'');


		console.log(catid);
});
